<template>
	<app-content class="h-panel">
		
		<router-view/>
	</app-content>
</template>

<script>
	export default {
		name: "cashier",
		data() {
			return { 
				selected: 'cashier'
			}
		},
		methods: {
			change(data) {
				this.$router.push({name: data.key})
			}
		}
	}
</script>